import Axios from 'axios';
import React, { useMemo, useState } from 'react'
import { NumberConvert } from '../../../common/numberConvert';
import { elapsedTime } from '../../../common/howDate';

const UserPointList = () => {
  
  const [userPointMinus, setUserPointMinus] = useState([]);
  const [userPointPlus, setUserPointPlus] = useState([]);

  useMemo(()=>{
    let Mount = true;

    // 포인트 최다 및 최저 랭킹
    const UserPointData = async ()=>{
      await Axios.get('/api/Point_store/UserPointList')
      .then((res)=>{
        if(Mount){
          setUserPointPlus(res.data[0]);
          setUserPointMinus(res.data[1]);
        }
      })
    };
    UserPointData();

    return ()=>{
      Mount = false;
    }
  }, [])
    
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-3 w-full tracking-wide'>

      {/* 플러스 리스트 */}
      <div className='bg-[#2E2E2E] overflow-x-auto whitespace-nowrap rounded-sm'>
        <table id='tb_table' className='w-full'>
          {/* <thead className='bg-[#424242] whitespace-nowrap text-center border-b-[1px] border-gray-500'>
            <tr className=''>
              {columns_tb.map((column) => (
                <th className='p-3' key={column}>{column}</th>
              ))}
            </tr>
          </thead> */}
          <tbody className='text-center text-stone-300 border-[1px] border-[#3E3E3E]'>
            {
              userPointPlus.map((item, index) => (
                <tr className='even:bg-[#3E3E3E]' key={index}>
                  <td className='p-1 py-2'>🔼</td>
                  <td className='p-1 py-2 border-x-[1px] border-[#4E4E4E]'>{item.id}</td>
                  <td className='p-1 py-2 border-r-[1px] border-[#4E4E4E]'>
                    +{NumberConvert(item.point)} P
                  </td>
                  <td className='p-1 py-2 border-x-[1px] border-[#4E4E4E]'>{item.log}</td>
                  <td className='p-1 py-2 text-xs'>{elapsedTime(item.date)}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      {/* 🔺🔻➕➖🔼⏫🔽⏬0️⃣1️⃣2️⃣3️⃣4️⃣5️⃣6️⃣7️⃣8️⃣9️⃣🔟 */}

      {/* 마이너스 리스트 */}
      <div className='bg-[#2E2E2E] overflow-x-auto whitespace-nowrap rounded-sm'>
        <table id='tb_table' className='w-full'>
          <tbody className='text-center text-stone-300 border-[1px] border-[#3E3E3E]'>
            {
              userPointMinus.map((item, index) => (
                <tr className=' even:bg-[#3E3E3E]' key={index}>
                  <td className='p-1 py-2'>🔻</td>
                  <td className='p-1 py-2 border-x-[1px] border-[#4E4E4E]'>{item.id}</td>
                  <td className='p-1 py-2 border-x-[1px] border-[#4E4E4E]'>
                    -{NumberConvert(`${item.point}`.slice(1, 10))} P
                  </td>
                  <td className='p-1 py-2 border-x-[1px] border-[#4E4E4E]'>{item.log}</td>
                  <td className='p-1 py-2 text-xs'>{elapsedTime(item.date)}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

    </div>
  )
}

export default UserPointList